// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__16Jmu","errorLogs":"EditorFooter_errorLogs__N30gm"};